import ready, { HTML } from './utils';
import initMobileNav from './components/burgerMenu';
import initStickyScrollBlock from './components/fiexdHeader';
import initSlickCarousel from './components/carousel';
import initRetinaCover from './components/retina';
import initSameHeight from './components/sameHeight';
import InfiniteScroll from "infinite-scroll";
import ajaxFilter from './components/ajaxFilter';
import initAccessibility from './components/accessibility';

ready(() => {
  HTML.classList.add('is-loaded');
  initMobileNav();
  // initStickyScrollBlock();
  initSlickCarousel();
  initRetinaCover();
  // initSameHeight();

  if( document.querySelector('.search-results') ){
    let elem = document.querySelector('.result-list');
    
    let infScroll = new InfiniteScroll( elem, {
      // options
      path: '.next-posts-link',
      append: '.serp',
      history: false,
      button: '.next-posts-link',
      scrollThreshold: false
    });

    const button = document.querySelector('.next-posts-link');

    infScroll.on( 'request', function( path, fetchPromise ) {
      // console.log(`Loading page: ${path}`);
      button.classList.add('loading');
    });

    infScroll.on( 'append', function( body, path, items, response ) {
      // console.log(`Appended ${items.length} items on ${path}`);
      button.classList.remove('loading');
    });

  }

  ajaxFilter();

  jQuery('.search-popup').on('mouseover', function(){
    jQuery('.search-form input[type="search"]').focus();
  });

  // initAccessibility();

});
